// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list-checks.js';

import { paths } from '../generated/list-checks';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list-checks', Original, paths);
